/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { AssetEdit } from "./AssetEdit/AssetEdit";
import { AssetEditComponent } from "./AssetEdit/AssetEditComponent";
import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { registerAssetCommands } from "./Commands";
import { registerAssetMenus } from "./Menus";
import { Editor } from "../../Editor";
import { CMD } from "../../commands/CMD";

export function AssetModule(dc: Editor): void {
	dc.get("logger").debug("Asset module enabled");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView("asset.edit", AssetEdit, AssetEditComponent);

	resourceSvc.registerResourceView(RESOURCE_TYPES.ASSET, "asset.edit");
	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.ASSET, CMD.ASSET.CREATE.OPEN_ADD);

	registerAssetCommands(dc);
	registerAssetMenus(dc);
}
